// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3elRP","col":"Table_col__3AvPH","fulfillmentStatus":"Table_fulfillmentStatus__3M3H_","emailCol":"Table_emailCol__1uZjc"};